import IzzyAnalyzeFailGif from '@/assets/images/izzy/analyze-fail.gif'
import { cn } from '@/lib/utils'
import { IzzySpeechBubble } from '../speech-bubble'

interface IzzyAnalyzeFailProps {
  className?: string
  label?: string
}

export const IzzyAnalyzeFail = ({ className, label }: IzzyAnalyzeFailProps) => {
  return (
    <div className={cn('select-none', className)}>
      <img
        src={IzzyAnalyzeFailGif}
        alt="Izzy não conseguiu ler o histŕocio acadêmico"
      />
      <div>
        <IzzySpeechBubble className="absolute w-60 left-40 bottom-38 flex flex-col gap-3">
          <p>{label}</p>
        </IzzySpeechBubble>
      </div>
    </div>
  )
}
